class WishlistAdd extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.triggerElement = null
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleCreate = this.handleCreate.bind(this)
    this.addToWishlist = this.addToWishlist.bind(this)
    this.focusDialogOnOpen = this.focusDialogOnOpen.bind(this)

    this.checkLoggedIn = this.checkLoggedIn.bind(this)
    this.checkIsInWishlist = this.checkIsInWishlist.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)
    this.listeners.add(this, 'click', this.handleSubmit)

    this.listeners.add(this.els.create.element, 'click', this.handleCreate)

    this.populateProductInfo = this.populateProductInfo.bind(this)
    this.populateLists = this.populateLists.bind(this)

    this.handleVariantChange = this.handleVariantChange.bind(this)
    this.listeners.add(this, 'change', this.handleVariantChange)

    this.listeners.add(document, 'checkIsInWishlist', this.checkIsInWishlist)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.WISHLIST.CHECK_WISHLIST,
      this.checkIsInWishlist,
    )

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push((swat) => {
      this.checkLoggedIn()

      this.checkIsInWishlist()

      this.externalEls.trigger?.elements.forEach((el) => {
        el.setAttribute('data-wishlist-active', '')
      })
    })
  }

  checkLoggedIn () {
    if (this.hasAttribute('data-is-customer')) return

    /* eslint-disable no-console */
    window._swat.disconnectShopperContext(
      (onSuccess) => console.log('User cleared'),
      this.wishlistError,
    )
    /* eslint-enable */
  }

  handleClose () {
    this.checkIsInWishlist()

    window.drawers.activeDrawerKey = ''

    // Return focus to the trigger element that opened the modal
    if (this.triggerElement && this.triggerElement.isConnected) {
      this.triggerElement.focus()
    }
  }

  async handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-add-external-el="trigger"]',
    )

    if (!trigger || !window._swat) return

    if (trigger.hasAttribute('data-wishlist-added')) {
      const lid = trigger.dataset.wishlistId

      const product = {
        epi: trigger.dataset.variantId,
        empi: trigger.dataset.productId,
        du: `${window.location.origin}${trigger.dataset.productUrl}`,
      }

      window._swat.deleteFromList(
        lid,
        product,
        this.checkIsInWishlist,
        this.wishlistError,
      )
    } else {
      // Store the trigger element to return focus when modal closes
      this.triggerElement = trigger

      window.drawers.activeDrawerKey = 'drawer-wishlist-add'
      this.focusDialogOnOpen()

      this.setAttribute('data-product-id', trigger.dataset.productId)
      this.setAttribute('data-variant-id', trigger.dataset.variantId)
      this.setAttribute('data-product-url', trigger.dataset.productUrl)
      this.setAttribute('data-cnstrc-item-id', trigger.dataset.productId)
      this.setAttribute(
        'data-cnstrc-item-variation-id',
        trigger.dataset.variantId,
      )

      this.populateProductInfo(
        `${trigger.dataset.productUrl}?variant=${trigger.dataset.variantId}`,
      )

      window._swat.fetchLists({
        callbackFn: this.populateLists,
        errorFn: this.wishlistError,
      })
    }
  }

  handleVariantChange (event) {
    const variantsChange = event.target.closest(
      '[data-wishlist-add-el="variants-select"]',
    )

    if (!variantsChange) return

    this.setAttribute('data-variant-id', variantsChange.value)
  }

  populateProductInfo (variantUrl) {
    return window.BAO.sectionRenderer
      .fetchSingle('wishlist-product-info', variantUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.shopify-section')

        if (myself) {
          this.els['product-info'].element.innerHTML = myself.innerHTML
        }
      })
      .catch(() => {
        return null
      })
  }

  populateLists (lists) {
    const listContainer = this.els.lists.element
    const listButtons = document.createDocumentFragment()

    lists.forEach((list) => {
      const button = document.createElement('button')
      button.type = 'button'
      button.className =
        'drw-WishlistAdd_Item btn-Button btn-Button-primary btn-Button-fullWidth'
      button.setAttribute('data-list-id', list.lid)
      button.setAttribute('data-wishlist-add-el', 'submit')
      button.setAttribute(
        'aria-label',
        `${list.lname}. ${list.cnt} items in this wishlist`,
      )

      const listName = document.createElement('span')
      listName.className = 'drw-WishlistAdd_ListName'
      listName.textContent = list.lname

      const visibleCount = document.createElement('span')
      visibleCount.setAttribute('aria-hidden', 'true')
      visibleCount.textContent = ` (${list.cnt})`

      const screenReaderCount = document.createElement('span')
      screenReaderCount.className = 'util-ScreenReaderOnly'
      screenReaderCount.textContent = `${list.cnt} items in this wishlist`

      listName.append(visibleCount, screenReaderCount)
      button.appendChild(listName)
      listButtons.appendChild(button)
    })

    listContainer.replaceChildren(listButtons)

    this.els['lists-header'].element.setAttribute(
      'aria-hidden',
      lists.length === 0,
    )
    this.els.newlist.element.value =
      lists.length === 0 ? window.theme.wishlist.wishlist : ''
  }

  handleSubmit (event) {
    const trigger = event.target.closest('[data-wishlist-add-el="submit"]')

    if (!trigger) return

    const listChoice = trigger.dataset.listId

    this.addToWishlist(listChoice)
  }

  handleCreate () {
    if (this.els.newlist.element.value === '') return

    const listConfig = {
      lname: this.els.newlist.element.value,
    }

    window._swat.createList(
      listConfig,
      (newList) => this.addToWishlist(newList.lid),
      this.wishlistError,
    )
  }

  addToWishlist (lid) {
    const product = {
      epi: parseInt(this.dataset.variantId),
      empi: parseInt(this.dataset.productId),
      du: `${window.location.origin}${this.dataset.productUrl}`,
    }

    // Use shared Constructor wishlist tracking helper
    if (window.trackConstructorWishlistConversion) {
      window.trackConstructorWishlistConversion(product.empi, product.epi)
    }

    window._swat.addToList(lid, product, this.handleClose, this.wishlistError)
  }

  checkIsInWishlist () {
    if (!window._swat) return

    window._swat.fetchLists({
      callbackFn: (lists) => {
        const productCount = lists.reduce(
          (accumulator, list) => accumulator + list.cnt,
          0,
        )
        this.externalEls.count?.elements.forEach((countEl) => {
          countEl.setAttribute('aria-hidden', productCount === 0)
          countEl.textContent = `(${productCount})`
        })

        this.externalEls.trigger?.elements.forEach((el) => {
          let matchedVariant
          const matchedWishlist = lists.find((list) =>
            list.listcontents.some((product) => {
              if (product.empi === parseInt(el.dataset.productId)) {
                matchedVariant = product.epi
                return true
              }
              return false
            }),
          )

          if (matchedWishlist) {
            el.setAttribute('data-wishlist-added', '')
            el.setAttribute('data-wishlist-id', matchedWishlist.lid)
            el.setAttribute('data-variant-id', matchedVariant)
          } else {
            el.removeAttribute('data-wishlist-added')
            el.removeAttribute('data-wishlist-id')
          }

          el.setAttribute('data-wishlist-active', '')
        })
      },
      errorFn: this.wishlistError,
    })
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log("Wishlist error", errorMessage);
  }

  focusDialogOnOpen () {
    window.requestAnimationFrame(() => {
      if (window.drawers?.activeDrawerKey !== 'drawer-wishlist-add') return

      const closeButton = this.querySelector('[data-drawers-close]')
      if (closeButton) {
        closeButton.focus({ preventScroll: true })
        return
      }

      const heading = this.els?.header?.element
      if (heading) {
        heading.setAttribute('tabindex', '-1')
        heading.focus({ preventScroll: true })
        return
      }

      const dialog = this.closest('[is="site-drawer"]')
      if (dialog) {
        dialog.setAttribute('tabindex', '-1')
        dialog.focus({ preventScroll: true })
      }
    })
  }
}

if (!customElements.get('wishlist-add')) {
  customElements.define('wishlist-add', WishlistAdd)
}
